import cleanStoredInfo from '../auth/cleanStoredInfo'

const cleanApp = async (reset?: () => void) => {
  await cleanStoredInfo()

  reset?.()
  return true
}

export default cleanApp
